import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "oasis-header" };
const _hoisted_2 = { class: "header-content" };
const _hoisted_3 = {
    key: 0,
    class: "mr-auto"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "max-md:hidden" };
const _hoisted_6 = { class: "header-actions" };
const _hoisted_7 = {
    href: "//www.curtin.edu.au",
    class: "curtin-logo"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "header-mobile-search hidden" };
import PButton from 'primevue/button';
import StyleClass from 'primevue/styleclass';
import { ref } from 'vue';
import CloseIcon from '../assets/icons/close.svg';
import LogoutIcon from '../assets/icons/logout.svg';
import OasisLogoIcon from '../assets/icons/oasis-logo.svg';
import SearchIcon from '../assets/icons/search.svg';
import { vTooltipAccessible } from '../utils/tooltip-directive';
import HeaderSearch from './header-search.vue';
import NamedIcon from './named-icon.vue';
// fixes TS2322 by coercing the ObjectDirective type definition mismatch
export default /*@__PURE__*/ _defineComponent({
    __name: 'oasis-header',
    props: {
        siteUrl: { default: '/' },
        curtinLogoUrl: { default: '//global.curtin.edu.au/responsive-assets/img/logo-curtin-university.png' },
        isAuthenticated: { type: Boolean, default: false },
        hasNav: { type: Boolean, default: false }
    },
    setup(__props) {
        const vStyleclass = StyleClass;
        const searchTerm = ref('');
        const mobileSearchShown = ref(false);
        const toggleMobileSearch = () => {
            mobileSearchShown.value = !mobileSearchShown.value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("header", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header-menu" }, null, -1)),
                    (!__props.hasNav)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("a", {
                                href: __props.siteUrl,
                                class: "oasis-logo",
                                "aria-label": "OASIS logo"
                            }, [
                                _createVNode(NamedIcon, {
                                    name: _unref(OasisLogoIcon).id,
                                    class: "oasis-logo-icon"
                                }, null, 8, ["name"])
                            ], 8, _hoisted_4)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(HeaderSearch, {
                            term: searchTerm.value,
                            "onUpdate:term": _cache[0] || (_cache[0] = ($event) => ((searchTerm).value = $event))
                        }, null, 8, ["term"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "actions"),
                        _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                            variant: "text",
                            severity: "tertiary",
                            rounded: "",
                            class: "header-btn-action search-btn",
                            "aria-label": mobileSearchShown.value ? 'Close' : 'Search',
                            onClick: toggleMobileSearch
                        }, {
                            default: _withCtx(() => [
                                _createVNode(NamedIcon, {
                                    name: mobileSearchShown.value ? _unref(CloseIcon).id : _unref(SearchIcon).id
                                }, null, 8, ["name"])
                            ]),
                            _: 1
                        }, 8, ["aria-label"])), [
                            [
                                _unref(vTooltipAccessible),
                                { value: mobileSearchShown.value ? 'Close' : 'Search', autoHide: false },
                                void 0,
                                {
                                    focus: true,
                                    bottom: true
                                }
                            ],
                            [_unref(vStyleclass), { selector: '.header-mobile-search', toggleClass: 'hidden' }]
                        ]),
                        (__props.isAuthenticated)
                            ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                                key: 0,
                                as: "a",
                                href: "/auth/logoff",
                                variant: "text",
                                severity: "tertiary",
                                rounded: "",
                                class: "header-btn-action logout-btn",
                                "aria-label": "Log Out"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(NamedIcon, {
                                        name: _unref(LogoutIcon).id
                                    }, null, 8, ["name"])
                                ]),
                                _: 1
                            })), [
                                [
                                    _unref(vTooltipAccessible),
                                    { value: 'Log Out', autoHide: false },
                                    void 0,
                                    {
                                        focus: true,
                                        bottom: true
                                    }
                                ]
                            ])
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("a", _hoisted_7, [
                        _createElementVNode("img", {
                            src: __props.curtinLogoUrl,
                            alt: "Visit Curtin University website"
                        }, null, 8, _hoisted_8)
                    ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(HeaderSearch, {
                        term: searchTerm.value,
                        "onUpdate:term": _cache[1] || (_cache[1] = ($event) => ((searchTerm).value = $event)),
                        expanded: ""
                    }, null, 8, ["term"])
                ])
            ]));
        };
    }
});
